import styled from "styled-components";

export const MyFeedToggle = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;

  border-bottom: 1px solid #f1f3f5;

  & .selected {
    font-weight: 700;
    color: #ff7a00;

    border-bottom: 2px solid #ff7a00;
  }
`;

// 댓글 탭
export const MyComments = styled.div`
  & .myComments {
    padding-top: 20px;
    padding-bottom: 20px;

    & .postContent {
      font-size: 12px;
      line-height: 20px;
      color: #4a5056;

      margin-bottom: 20px;
    }

    & .deletedPost {
      font-size: 12px;
      line-height: 20px;
      color: #4a5056;
      cursor: pointer;

      margin-bottom: 20px;
    }

    & .commentContent {
      font-size: 14px;
      line-height: 20px;

      margin-bottom: 16px;
    }

    & .aside {
      display: flex;
      justify-content: space-between;

      & .like {
        display: flex;

        & img {
          cursor: pointer;
        }

        & div {
          display: flex;
          &.orange {
            /* isLiked=true */
            color: #ff7a00;
            font-weight: 600;
            font-size: 12px;
            line-height: 20px;
          }
          &.black {
            /* isLiked=false */
            font-size: 12px;
            line-height: 20px;
            color: #878e95;
          }
        }
      }

      & .likeText {
        margin-left: 2px;
        margin-right: 2px;
      }

      & .createdAt {
        font-size: 12px;
        line-height: 20px;
        color: #aeb5bc;
      }
    }
  }

  & .boldLine {
    height: 8px;
    background-color: #f8f9fa;
  }
`;

export const Background = styled.div`
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  text-align: center;

  & > div {
    background-color: #fff;
    border-radius: 8px;

    & > div {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      text-align: center;

      margin: 28px 77px;
    }
  }
`;
